module.exports = __webpack_public_path__ + "img/9592c1f6eb504b56bd20f9f84db0bb28-1024.64cbe036.jpg";